import { render, staticRenderFns } from "./GameGrid.vue?vue&type=template&id=847433bc&scoped=true&"
import script from "./GameGrid.vue?vue&type=script&lang=js&"
export * from "./GameGrid.vue?vue&type=script&lang=js&"
import style0 from "./GameGrid.vue?vue&type=style&index=0&id=847433bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847433bc",
  null
  
)

export default component.exports